export enum AuthFormEnum {
  CONTRACT = 'contract',
  PHONE = 'phone'
}
